import { ISuggestedModalContext } from './suggestedModalContext';

export enum SuggestedModalActionTypes {
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_SUGGESTED_DISH_CATEGORY = 'SET_SUGGESTED_DISH_CATEGORY',
	SET_SUGGESTED_DISH_SUB_CATEGORY = 'SET_SUGGESTED_DISH_SUB_CATEGORY',
	SET_FETCHED_SUGGESTED_DISHES = 'SET_FETCHED_SUGGESTED_DISHES',
	SET_SUGGESTED_DISHES = 'SET_SUGGESTED_DISHES',
}

interface ISetAllData {
	type: SuggestedModalActionTypes.SET_ALL_DATA;
	payload: {
		dishInfo: ISuggestedModalContext['dishInfo'];
		IDsSelectedRestaurant: ISuggestedModalContext['IDsSelectedRestaurant'];
		fetchedSuggestedDishes: ISuggestedModalContext['fetchedSuggestedDishes'];
		selectedSuggestedDishes: ISuggestedModalContext['selectedSuggestedDishes'];
	};
}

interface ISetSuggestedDishCategory {
	type: SuggestedModalActionTypes.SET_SUGGESTED_DISH_CATEGORY;
	payload: {
		selectedSuggestedDishCategory: ISuggestedModalContext['selectedSuggestedDishCategory'];
	};
}

interface ISetSuggestedDishSubCategory {
	type: SuggestedModalActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY;
	payload: {
		selectedSuggestedDishSubCategory: ISuggestedModalContext['selectedSuggestedDishSubCategory'];
	};
}

interface ISetFetchedSuggestedDishes {
	type: SuggestedModalActionTypes.SET_FETCHED_SUGGESTED_DISHES;
	payload: {
		fetchedSuggestedDishes: ISuggestedModalContext['fetchedSuggestedDishes'];
	};
}

interface ISetSuggestedDishes {
	type: SuggestedModalActionTypes.SET_SUGGESTED_DISHES;
	payload: {
		selectedSuggestedDishes: ISuggestedModalContext['selectedSuggestedDishes'];
	};
}

export type TSuggestedModalAction =
	| ISetAllData
	| ISetSuggestedDishCategory
	| ISetSuggestedDishSubCategory
	| ISetFetchedSuggestedDishes
	| ISetSuggestedDishes;
